import { ResultDataPointTypes } from "../enums/Result";
import { Result } from "../interfaces/Result";

export function getSubstationDisplayName(result: Result) {
  const isPartialResult = result.dataPointTypeId === ResultDataPointTypes.Partial;

  if (isPartialResult) return result.dataValue.MetaData?.SubstationGroup?.SubstationName;
  else
    return (
      result.dataValue.SubstationSummary?.SubstationName ?? result.dataValue.MetaData?.SubstationGroup?.SubstationName
    );
}
